export default __webpack_public_path__ + "static/media/learose5-2048w.d3ff110a.avif";